import React, { Component, ReactNode } from 'react';
import { ColumnProps } from 'primereact/column';
import moment from 'moment';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import CustomEmptyComponent from 'components/custom/CustomEmptyComponent';
import CustomTable, { CustomColumnProps } from 'components/custom/CustomTable';
import CustomPaginator, { CustomPaginatorProps } from 'components/custom/CustomPaginator';
import { CaseSettings } from '../../../domain/case/CaseDomains';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { dispatch, RootState } from '../../../redux/store';
import {
  TransactionData,
  TransactionJsonModel,
  TransactionReason,
  TransactionResult,
  TransactionResultReason,
  TransactionVariableJsonModel,
} from '../../../domain/stream/transaction/TransactionDomains';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { query, repository, subscribe } from '@trlogic/client-js';
import CollectionNames from '../../../constant/CollectionNames';
import DataType from '../../../constant/DataType';
import { DataTableColReorderParams, DataTableRowClickEventParams, DataTableSortMeta } from 'primereact/datatable';
import NavigationUtil from '../../../util/NavigationUtil';
import { Tooltip } from 'primereact/tooltip';
import { ComponentState, setSelectedItems } from '../../../redux/actions/ComponentActions';
import Icon from '../../../icons/Icon';
import CustomTableContentWrapper from '../../custom/CustomTableContentWrapper';
import { Dialog } from 'primereact/dialog';
import { Tree } from 'primereact/tree';
import { generateUUID } from '../../../util/Generator';
import TreeNode from 'primereact/treenode';
import { User, UserSystemAttributes } from '../../../domain/rbac/RbacDomains';
import { CaseState } from '../../../redux/reducers/CaseReducer';
import { changeCaseColumns, changeListDataLoading } from '../../../redux/actions/CaseActions';
import ComponentName from '../../../constant/ComponentName';
import { setAttribute } from '../../../redux/actions/UserActions';
import ValueFactory from '../../../util/ValueFactory';
import CustomSkeleton from '../../custom/CustomSkeleton';
import {
  CustomFilter as FilterType,
  CustomFilterCategorical,
  CustomFilterDateSearch,
  CustomFilterFields,
  CustomFilterLiteralSearch,
} from '../../../domain/ui/FilterDomains';
import { PageState } from '../../../redux/reducers/PageReducer';
import { changePageFilter } from 'redux/actions/PageActions';
import FilterUtil from '../../../util/FilterUtil';
import LanguageUtil from '../../../util/LanguageUtil';
import ValueUtil from '../../../util/ValueUtil';
import DateFormatUtil from '../../../util/DateFormatUtil';
import { DateVariableProperties } from '../../../domain/datatype/VariablePropertiesDomains';
import TransactionFailureModalComponent from 'components/investigation/case/widget/TransactionFailureModalComponent';
import TransactionResultModalComponent from 'components/investigation/case/widget/TransactionResultModalComponent';
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;
import Order = query.Order;
import Computation = subscribe.Computation;
import Filter = query.Filter;

class AchTransactionsActivityComponent extends Component<Props, State> {
  public state: State = new State();

  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private userSystemAttributeSubscription: subscribe.Subscription | undefined;
  private transactionSubscription: subscribe.Subscription | undefined;
  private computation: Computation | undefined;

  public render(): ReactNode {
    const { currentPage, rows, transactionFailureVisible, transactionFailures, structureVisible, structureData, transactionResultVisible, transactionResult } =
      this.state;
    const {
      transactions,
      paginationFixed,
      total,
      multiple,
      loading,
      component: { selectedComponentIds },
      onSortChange,
    } = this.props;
    const columns = this.getColumns();
    const isEmpty = transactions.length == 0 && columns.length > 0 && !loading;
    const isLoading = loading || columns.length == 0;

    return (
      <div className='w-full h-full flex flex-col overflow-y-scroll '>
        {isEmpty ? (
          <div className={'h-[100vh] w-full flex items-center justify-center'}>
            <CustomEmptyComponent
              label={LanguageUtil.get({
                id: 'components.emptyComponent.anyTransaction',
                defaultMessage: 'You currently do not have any transactions',
              })}
            />
          </div>
        ) : isLoading ? (
          <CustomSkeleton />
        ) : (
          <div>
            <div className={'flex justify-between bg-white items-center w-full overflow-x-scroll overflow-y-hidden h-full !max-h-[calc(100vh-375px)] '}>
              <CustomTable
                scrollable={true}
                scrollHeight={'flex'}
                columns={columns}
                key={this.props.filterKey}
                rowClassName={this.onRowClassName}
                onRowClick={this.onRowClick}
                onSortChange={onSortChange}
                value={transactions}
                selectionMode={multiple ? 'checkbox' : undefined}
                onSelectionChange={this.onSelectionChange}
                selection={selectedComponentIds}
                reorderableColumns
                multiSortMeta={this.getOrder()}
                onColReorder={this.onColReorder}
              />
            </div>
            <CustomPaginator
              currentPage={currentPage}
              currentRecords={transactions.length}
              key='case-transaction-activity'
              rows={rows}
              totalRecords={total > 10_000 ? 10_000 : total}
              loading={loading}
              fixed={paginationFixed}
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              onPageChange={this.onPageChange}
            />
          </div>
        )}
        <TransactionFailureModalComponent failures={transactionFailures} visible={transactionFailureVisible} onClose={this.closeFailures} />
        {transactionResult && <TransactionResultModalComponent result={transactionResult} visible={transactionResultVisible} onClose={this.closeResult} />}
        <Dialog
          className={'h-1/2 w-1/3'}
          headerClassName={'!pb-0'}
          closable={false}
          header={<span className={'text-[15px] text-normal'}>Structure Items</span>}
          dismissableMask
          closeOnEscape
          visible={structureVisible}
          onHide={this.structureModalClose}
        >
          <Tree value={structureData} className={'border-none h-full w-full text-[13px] p-0 pt-2'} />
        </Dialog>
      </div>
    );
  }

  public async componentDidMount() {
    const { currentPage, rows, changeListDataLoading } = this.props;
    changeListDataLoading(true);
    if (currentPage != undefined) {
      this.setState({ currentPage });
    }
    if (rows != undefined) {
      this.setState({ rows });
    }
    this.startTracker();
  }

  private startTracker = () => {
    const { user, selectedAlarmDomain } = this.props;
    const attrQuery = QueryBuilder.select().from(CollectionNames.USER_SYSTEM_ATTRIBUTES).where(eq('username', user.username)).build();
    this.userSystemAttributeSubscription = subscribe.Formica.subscribe(CollectionNames.USER_SYSTEM_ATTRIBUTES, attrQuery);

    if (selectedAlarmDomain?.dataSource) {
      const transactionQuery = QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq('id', selectedAlarmDomain.dataSource)).build();
      this.transactionSubscription = subscribe.Formica.subscribe(CollectionNames.TRANSACTIONS, transactionQuery);
      this.computation = subscribe.Tracker.autorun(this.tracker, [this.userSystemAttributeSubscription, this.transactionSubscription]);
    } else {
      this.computation = subscribe.Tracker.autorun(this.tracker, [this.userSystemAttributeSubscription]);
    }
  };

  private tracker = async () => {
    const { user, setAttribute, selectedAlarmDomain } = this.props;
    const isUserAttributesReady = this.userSystemAttributeSubscription?.ready();
    const isTransactionReady = !selectedAlarmDomain?.dataSource || this.transactionSubscription?.ready();

    if (isUserAttributesReady && isTransactionReady) {
      const attrQuery = QueryBuilder.select().from(CollectionNames.USER_SYSTEM_ATTRIBUTES).where(eq('id', user.username)).build();
      const attr = (await this.repository.find<UserSystemAttributes>(attrQuery)) ?? ValueFactory.initializeUserAttribute();
      setAttribute(attr);
      if (selectedAlarmDomain) {
        this.prepareColumns(attr);
      }
    }
  };

  private stopTracker = () => {
    this.userSystemAttributeSubscription?.stop();
    this.transactionSubscription?.stop();
    this.computation?.stop();
  };

  public componentWillUnmount() {
    this.stopTracker();
  }

  public async componentDidUpdate(prevProps: Readonly<Props>) {
    const { update, systemAttributes, selectedAlarmDomain } = this.props;
    const { currentPage, rows } = this.props;
    const shouldUpdate = update != undefined && update != prevProps.update;
    const shouldUpdateColumns =
      selectedAlarmDomain?.dataSource !== prevProps.selectedAlarmDomain?.dataSource ||
      (prevProps.selectedAlarmDomain === undefined && selectedAlarmDomain !== undefined);

    if (shouldUpdateColumns && selectedAlarmDomain?.dataSource) {
      this.transactionSubscription?.stop();
      const transactionQuery = QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq('id', selectedAlarmDomain.dataSource)).build();
      this.transactionSubscription = subscribe.Formica.subscribe(CollectionNames.TRANSACTIONS, transactionQuery);

      this.computation?.stop();
      if (this.userSystemAttributeSubscription) {
        this.computation = subscribe.Tracker.autorun(this.tracker, [this.userSystemAttributeSubscription, this.transactionSubscription]);
      }
    }

    if (shouldUpdate || shouldUpdateColumns) {
      if (currentPage != undefined) {
        this.setState({ currentPage });
      }
      if (rows != undefined) {
        this.setState({ rows });
      }
      if (systemAttributes) {
        await this.prepareColumns(systemAttributes);
      }
    }
  }

  private getColumns = () => {
    const {
      case: { columns },
    } = this.props;
    return columns[this.getKey()] ?? [];
  };

  private onRowClick = async (e: DataTableRowClickEventParams) => {
    const {
      openInNewPage,
      router: { navigate },
      fileName,
    } = this.props;
    const record: TransactionData = e.data;

    const transactionId = (record as any)._id || record.id;

    if (!transactionId) return;
    const urlParams = new URLSearchParams();
    urlParams.set('transactionId', transactionId);
    if (fileName) {
      urlParams.set('fileName', fileName);
    }
    const url = `/ach/detail/${urlParams.toString()}`;

    if (openInNewPage) {
      window.open(`/${NavigationUtil.getTenant()}${url}`, '_blank', 'noopener noreferrer');
    } else {
      navigate(url);
    }
  };

  private prepareColumns = async (attribute: UserSystemAttributes) => {
    const { selectedAlarmDomain, user } = this.props;
    const riskType = user.activeRiskType;
    const columns: CustomColumnProps[] = [
      {
        field: 'id.keyword',
        sortField: 'id.keyword',
        header: LanguageUtil.get({ id: 'pages.case.table.id', defaultMessage: 'ID' }),
        alignHeader: 'left',
        className: 'min-w-[220px] 2xl:min-w-[300px]',
        copyable: true,
        filterable: true,
        addFilter: (e: TransactionData) => {
          this.addFilter('id', e.id, 'ID', DataType.STRING);
        },
        onCopy: (e: TransactionData) => {
          return e.id;
        },
        body: (record: TransactionData) => {
          return (
            <div
              className={`flex w-full text-xs 2xl:text-md items-start text-f-black-3 justify-start relative group`}
              data-testid={`${ComponentName.ACH}_id_${record.id}`}
            >
              <CustomTableContentWrapper clipSize={20} text={record.id} />
            </div>
          );
        },
      },
      {
        field: 'score',
        header: LanguageUtil.get({ id: 'pages.case.table.score', defaultMessage: 'Score' }),
        sortField: `result.${riskType}.score`,
        alignHeader: 'left',
        columnKey: 'score',
        className: 'min-w-[120px] max-w-[120px] 2xl:min-w-[150px] 2xl:max-w-[150px]',
        copyable: true,
        filterable: true,
        addFilter: (e: TransactionData) => {
          this.addFilter(`result.${riskType}.score`, e.result[riskType]?.score, 'Score', DataType.NUMBER);
        },
        onCopy: (e: TransactionData) => {
          return e.result[riskType].score.toString();
        },
        body: (record: TransactionData) => {
          const result = record.result[riskType];
          if (result == undefined) return;
          return (
            <div
              className={`flex flex-col text-xs 2xl:text-md justify-center items-center ${this.getScoreItem(result.score)} w-[40px] rounded-full  h-[22px]`}
              data-testid={`${ComponentName.ACH}_score_${record.id}`}
            >
              {result.score}
            </div>
          );
        },
      },
      {
        field: 'rule',
        header: LanguageUtil.get({ id: 'pages.case.table.rule', defaultMessage: 'Rule' }),
        sortable: false,
        alignHeader: 'left',
        columnKey: 'rule',
        className: 'min-w-[180px] 2xl:min-w-[220px]',
        body: (record: TransactionData, { rowIndex }) => {
          const result = record.result[user.activeRiskType];
          if (result == undefined) return;
          return (
            <div
              className={'flex items-start text-[#728EFF] text-xs 2xl:text-md justify-start relative group'}
              data-testid={`${ComponentName.ACH}_rule_container_${record.id}`}
            >
              {result.rules?.length > 0 ? (
                <Tooltip target={`#detection_${rowIndex}`}>
                  <div className='grid grid-cols-3 gap-x-3 gap-y-1.5'>
                    {result.rules?.map((r, i) => (
                      <span key={r.name} data-testid={`${ComponentName.ACH}_rule_${i}_${record.id}`}>
                        {r.name} - {r.score} - {r.resolution}
                      </span>
                    ))}
                  </div>
                </Tooltip>
              ) : null}
              <span id={`detection_${rowIndex}`} data-testid={`${ComponentName.ACH}_rule_title_${record.id}`} className={'detection'}>
                {LanguageUtil.get({ id: 'pages.case.table.detectedBy' }, { 0: `${result.rules?.length.toString() || 0}` })}
              </span>
            </div>
          );
        },
      },
      {
        field: `result.${riskType}.metadata.assignee.id.keyword`,
        sortField: `result.${riskType}.metadata.assignee.id.keyword`,
        header: LanguageUtil.get({ id: 'pages.case.table.assignee', defaultMessage: 'Assignee' }),
        alignHeader: 'left',
        columnKey: `result.${riskType}.metadata.assignee.id.keyword`,
        className: 'min-w-[250px] 2xl:min-w-[300px]',
        copyable: true,
        filterable: true,
        addFilter: (e: TransactionData) => {
          this.addFilter(
            `result.${riskType}.metadata.assignee.id.keyword`,
            e.result[user.activeRiskType].metadata?.assignee?.id || 'System',
            'Assignee',
            DataType.STRING,
            true,
          );
        },
        onCopy: (e: TransactionData) => {
          return e.result[user.activeRiskType].metadata?.assignee?.id || 'No one assigned';
        },
        body: (record: TransactionData) => {
          const result = record.result[user.activeRiskType];
          if (result == undefined) return;
          let value;
          const assignee = result.metadata?.assignee?.id;
          const assigneeFirstName = result.metadata?.assignee?.firstName;
          const assigneeLastName = result.metadata?.assignee?.lastName;
          if (assigneeFirstName != undefined && assigneeFirstName != '' && assigneeLastName != undefined && assigneeLastName != '') {
            value = `${assigneeFirstName} ${assigneeLastName}`;
          } else {
            value = assignee || LanguageUtil.get({ id: 'pages.case.table.noOneAssigned', defaultMessage: 'No one assigned' });
          }
          return (
            <div className={'flex items-center text-f-black-3 text-xs 2xl:text-md'}>
              {value.length > 0 && (
                <div className={'w-7 h-7 flex items-center justify-center rounded-full bg-[#F4F3FF] mr-1'}>
                  {`${assigneeFirstName?.substring(0, 1)?.toUpperCase() || ''}${assigneeLastName?.substring(0, 1)?.toUpperCase() || ''}` || 'S'}
                </div>
              )}
              <span>
                <CustomTableContentWrapper text={value} data-testid={`${ComponentName.ACH}_assign_${record.id}`} />
              </span>
            </div>
          );
        },
      },
      {
        field: `result.${riskType}.resolution.keyword`,
        sortField: `result.${riskType}.resolution.keyword`,
        header: LanguageUtil.get({ id: 'pages.case.table.resolution', defaultMessage: 'Resolution' }),
        alignHeader: 'left',
        columnKey: `result.${riskType}.resolution.keyword`,
        className: 'min-w-[150px] 2xl:min-w-[200px]',
        copyable: true,
        filterable: true,
        addFilter: (e: TransactionData) => {
          this.addFilter(`result.${riskType}.resolution.keyword`, e.result[user.activeRiskType].resolution, 'Resolution', DataType.STRING, true);
        },
        onCopy: (e: TransactionData) => {
          return this.getStatusText(e.result[user.activeRiskType].resolution);
        },
        body: (record: TransactionData) => {
          const result = record.result[user.activeRiskType];
          if (result == undefined) return;
          return (
            <div
              className={`flex flex-col justify-center items-center text-xs 2xl:text-md rounded-full ${this.getStatusItem(result.resolution)} min-w-[86px] max-w-[150px] h-[22px]`}
              data-testid={`${ComponentName.ACH}_resolution_${record.id}`}
            >
              {this.getStatusText(result.resolution)}
            </div>
          );
        },
      },
      {
        field: `result.${riskType}.status.keyword`,
        sortField: `result.${riskType}.status.keyword`,
        header: LanguageUtil.get({ id: 'pages.case.table.status', defaultMessage: 'Status' }),
        alignHeader: 'left',
        columnKey: `result.${riskType}.status.keyword`,
        className: 'min-w-[250px] 2xl:min-w-[300px]',
        copyable: true,
        filterable: true,
        addFilter: (e: TransactionData) => {
          this.addFilter(`result.${riskType}.status.keyword`, e.result[user.activeRiskType].status, 'Status', DataType.STRING, true);
        },
        onCopy: (e: TransactionData) => {
          return this.getStatusText(e.result[user.activeRiskType].status);
        },
        body: (record: TransactionData) => {
          const result = record.result[user.activeRiskType];
          if (result == undefined) return;
          return (
            <div
              className={`flex flex-col justify-center items-center text-xs 2xl:text-md rounded-full ${this.getStatusItem(result.status)} w-[170px] h-[22px]`}
              data-testid={`${ComponentName.ACH}_status_${record.id}`}
            >
              {this.getStatusText(result.status)}
            </div>
          );
        },
      },
      {
        field: 'createdAt',
        header: LanguageUtil.get({ id: 'pages.case.table.createdAt', defaultMessage: 'Created At' }),
        alignHeader: 'left',
        columnKey: 'createdAt',
        className: 'min-w-[250px] 2xl:min-w-[300px]',
        copyable: true,
        filterable: true,
        addFilter: (e: TransactionData) => {
          this.addFilter(`createdAt`, e.createdAt, 'Date', DataType.DATE);
        },
        onCopy: (e: TransactionData) => {
          return DateFormatUtil.formatEpochForDisplay(e.createdAt);
        },
        body: (record: TransactionData) => {
          return (
            <div className={'flex items-start text-f-black-3 text-xs 2xl:text-md'}>
              <CustomTableContentWrapper
                text={DateFormatUtil.formatEpochForDisplay(record.createdAt)}
                tooltipText={DateFormatUtil.formatForTooltip(record.createdAt, 'epochMillis')}
                data-testid={`${ComponentName.ACH}_createdAt_${record.id}`}
              />
            </div>
          );
        },
      },
      {
        field: `result.${riskType}.metadata.review.endDate`,
        header: LanguageUtil.get({ id: 'pages.case.table.closedAt', defaultMessage: 'Closed At' }),
        alignHeader: 'left',
        columnKey: `result.${riskType}.metadata.review.endDate`,
        className: 'min-w-[250px]',
        copyable: true,
        filterable: true,
        sortField: `result.${riskType}.metadata.review.endDate`,
        addFilter: (e: TransactionData) => {
          this.addFilter(`result.${riskType}.metadata.review.endDate`, e.result?.[riskType]?.metadata?.review?.endDate, 'Closed At', DataType.DATE);
        },
        onCopy: (e: TransactionData) => {
          const endDate = e.result?.[riskType]?.metadata?.review?.endDate;
          return endDate ? DateFormatUtil.formatEpochForDisplay(endDate) : '';
        },
        body: (record: TransactionData) => {
          const endDate = record.result?.[riskType]?.metadata?.review?.endDate;
          return (
            <div className={'flex items-start text-f-black-3 text-xs 2xl:text-md'}>
              <CustomTableContentWrapper
                text={endDate ? DateFormatUtil.formatEpochForDisplay(endDate) : ''}
                tooltipText={endDate ? DateFormatUtil.formatForTooltip(endDate, 'epochMillis') : undefined}
                data-testid={`${ComponentName.ACH}_closedAt_${record.id}`}
              />
            </div>
          );
        },
      },
    ];
    if (selectedAlarmDomain != undefined && selectedAlarmDomain.keyField != undefined) {
      const transactionQuery = QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq('id', selectedAlarmDomain.dataSource)).build();
      const transaction = await this.repository.find<TransactionJsonModel>(transactionQuery);
      const keyFieldHeader = transaction?.variables?.find((v) => v?.name == selectedAlarmDomain.keyField)?.description || selectedAlarmDomain.keyField;
      columns.splice(1, 0, {
        field: `variables.${selectedAlarmDomain.keyField}.keyword`,
        sortField: `variables.${selectedAlarmDomain.keyField}.keyword`,
        header: keyFieldHeader,
        alignHeader: 'left',
        columnKey: `variables.${selectedAlarmDomain.keyField}.keyword`,
        className: 'min-w-[200px] 2xl:min-w-[250px]',
        copyable: true,
        filterable: true,
        addFilter: (e: TransactionData) => {
          this.addFilter(
            `variables.${selectedAlarmDomain.keyField}.keyword`,
            e.variables[selectedAlarmDomain.keyField],
            selectedAlarmDomain.keyField,
            DataType.STRING,
          );
        },
        onCopy: (record: TransactionData) => {
          return record.variables[selectedAlarmDomain.keyField];
        },
        body: (record: TransactionData) => {
          return (
            <div
              className={`flex items-start text-f-black-3 text-xs 2xl:text-md`}
              data-testid={`${ComponentName.ACH}_variable_${selectedAlarmDomain.keyField}_${record.id}`}
            >
              <CustomTableContentWrapper
                clipSize={30}
                text={record.variables[selectedAlarmDomain.keyField]}
                data-testid={`${ComponentName.ACH}_variable_${selectedAlarmDomain.keyField}_${record.id}`}
              />
            </div>
          );
        },
      });
      columns.splice(
        8,
        0,
        {
          field: `result.${riskType}.metadata.code.keyword`,
          sortField: `result.${riskType}.metadata.code.keyword`,
          header: LanguageUtil.get({ id: 'pages.case.table.reason', defaultMessage: 'Reason' }),
          alignHeader: 'left',
          columnKey: `result.${riskType}.metadata.code.keyword`,
          className: 'min-w-[200px] 2xl:min-w-[250px]',
          addFilter: (record: TransactionData) => {
            this.addFilter(`result.${riskType}.metadata.code.keyword`, record.result[user.activeRiskType]?.metadata?.code, 'Reason', DataType.STRING);
          },
          filterable: true,
          copyable: true,
          onCopy: (record: TransactionData) => {
            const result = record.result[user.activeRiskType];
            if (result == undefined) return;
            return result.metadata?.code ? selectedAlarmDomain.closeCodes.find((reason) => reason.code == result.metadata?.code)?.code || 'N/A' : 'N/A';
          },
          body: (record: TransactionData) => {
            const result = record.result[user.activeRiskType];
            return (
              <div
                className={`flex flex-col justify-center items-start text-xs 2xl:text-md rounded-[4px] min-w-[86px] max-w-[150px] h-[22px]`}
                data-testid={`${ComponentName.ACH}_reason_${record.id}`}
              >
                {result?.metadata?.code || 'N/A'}
              </div>
            );
          },
        },
        {
          field: 'timeToFA',
          header: LanguageUtil.get({ id: 'pages.case.table.timeToFa', defaultMessage: 'Time to FA' }),
          sortable: false,
          alignHeader: 'center',
          columnKey: 'timeToFA',
          className: 'min-w-[250px] 2xl:min-w-[300px]',
          body: (record: TransactionData) => {
            const result = record.result[user.activeRiskType];
            if (result == undefined) return;
            let timeToFA = 0;
            let timeToFirstAssign = selectedAlarmDomain?.sla.timeToFirstAssign.value;
            const createdAt = record.createdAt;
            const firstAssignedAt = result.metadata?.assignee?.assignmentDuration;
            if (timeToFirstAssign) {
              timeToFirstAssign = timeToFirstAssign * 60 * 1000;
              if (firstAssignedAt != undefined) {
                timeToFA = timeToFirstAssign - firstAssignedAt;
              } else if (result.status === TransactionReason.WAITING_FOR_REVIEW) {
                timeToFA = timeToFirstAssign - (moment().valueOf() - createdAt);
              } else {
                timeToFA = timeToFirstAssign;
              }
            }
            const sign = Math.sign(timeToFA);
            let formattedTime;
            if (sign == -1 || sign == -0) {
              formattedTime = Math.ceil(timeToFA / (60 * 60 * 1000)) + 'h ' + Math.ceil((timeToFA % (60 * 60 * 1000)) / (60 * 1000)) + 'm';
            } else {
              formattedTime = Math.floor(timeToFA / (60 * 60 * 1000)) + 'h ' + Math.floor((timeToFA % (60 * 60 * 1000)) / (60 * 1000)) + 'm';
            }
            return (
              <div
                className={`${timeToFA < 0 ? 'bg-[#FFF1F3]' : firstAssignedAt != undefined && timeToFA > 0 ? 'bg-[#DDFBEA]' : 'bg-[#F2F4F7]'} h-6 border border-1 rounded-full px-4 flex items-center justify-center gap-x-2`}
              >
                <CustomTableContentWrapper text={formattedTime} data-testid={`${ComponentName.ACH}_tfa_${record.id}`} />
                <Icon icon={'first-seen'} size={18} />
              </div>
            );
          },
        },
        {
          field: 'timeToDone',
          header: LanguageUtil.get({ id: 'pages.case.table.timeToDone', defaultMessage: 'Time to Done' }),
          sortable: false,
          alignHeader: 'center',
          columnKey: 'timeToDone',
          className: 'min-w-[250px] 2xl:min-w-[300px]',
          body: (record: TransactionData) => {
            const result = record.result[user.activeRiskType];
            if (result == undefined) return;
            let timeToDone = 0;
            let timeToFirstAssign = selectedAlarmDomain?.sla.timeToFirstAssign.value;
            const reviewStartDate = result.metadata?.review?.startDate;
            const reviewTime = result?.metadata?.review?.duration;
            if (timeToFirstAssign) {
              timeToFirstAssign = timeToFirstAssign * 60 * 1000;
              if (reviewStartDate == undefined) {
                timeToDone = timeToFirstAssign;
              } else if (result.metadata?.code == undefined) {
                timeToDone = timeToFirstAssign - (moment().valueOf() - reviewStartDate);
              } else if (reviewTime != undefined) {
                timeToDone = timeToFirstAssign - reviewTime;
              }
            }
            const sign = Math.sign(timeToDone);
            let formattedTime;
            if (sign == -1 || sign == -0) {
              formattedTime = Math.ceil(timeToDone / (60 * 60 * 1000)) + 'h ' + Math.ceil((timeToDone % (60 * 60 * 1000)) / (60 * 1000)) + 'm';
            } else {
              formattedTime = Math.floor(timeToDone / (60 * 60 * 1000)) + 'h ' + Math.floor((timeToDone % (60 * 60 * 1000)) / (60 * 1000)) + 'm';
            }
            return (
              <div
                className={`${timeToDone < 0 ? 'bg-[#FFF1F3]' : result.metadata?.code != undefined && timeToDone > 0 ? 'bg-[#DDFBEA]' : 'bg-[#F2F4F7]'}  h-6 border border-1 rounded-full px-4 flex items-center justify-center gap-x-2`}
              >
                <CustomTableContentWrapper text={formattedTime} data-testid={`${ComponentName.ACH}_ttd_${record.id}`} />
                <Icon icon={'schedule'} size={14} />
              </div>
            );
          },
        },
      );
    }
    const transactionFields = await this.prepareTransactionFields();
    columns.push(...transactionFields);
    columns.push({
      field: 'response',
      header: LanguageUtil.get({ id: 'pages.case.table.response', defaultMessage: 'Response' }),
      sortable: false,
      alignHeader: 'center',
      columnKey: 'response',
      className: 'min-w-[100] 2xl:min-w-[200px]',
      body: (record: TransactionData) => {
        return (
          <div className={'flex flex-col justify-center items-center min-w-[86px] max-w-[150px] text-xs 2xl:text-md'}>
            <button
              onClick={() => this.showResult(record.result[user.activeRiskType])}
              className={'text-[#458EF7]'}
              data-testid={`${ComponentName.ACH}_response_${record.id}`}
            >
              {LanguageUtil.get({ id: 'pages.case.table.showResponse', defaultMessage: 'Show Response' })}
            </button>
          </div>
        );
      },
    });
    columns.push({
      field: 'failures',
      header: LanguageUtil.get({ id: 'pages.case.table.failures', defaultMessage: 'Failures' }),
      sortable: false,
      alignHeader: 'center',
      columnKey: 'failures',
      className: 'min-w-[100]',
      body: (record: TransactionData) => {
        return (
          <div className={'flex flex-col justify-center items-center min-w-[86px] max-w-[150px] text-f-black-3 text-xs 2xl:text-md'}>
            {record.result.failures.length == 0 ? (
              'N/A'
            ) : (
              <button onClick={() => this.showFailures(record.result.failures)} data-testid={`${ComponentName.ACH}_failures_${record.id}`}>
                Show
                {LanguageUtil.get({ id: 'pages.case.table.failures', defaultMessage: 'Failures' })}
              </button>
            )}
          </div>
        );
      },
    });
    const table = attribute.table.find((t) => t.component == ComponentName.ACH && t.id == selectedAlarmDomain?.dataSource);
    if (attribute && table) {
      for (const hiddenColumn of table.hiddenColumns) {
        const column = columns.find((c) => c.field == hiddenColumn);
        if (column) {
          column.hidden = true;
        }
      }
    }
    if (table && table.columnOrder.length > 0) {
      table.columnOrder.forEach((column, index) => {
        const col = columns.findIndex((c) => c.field == column);
        if (col != -1) {
          const column = columns.splice(col, 1)[0];
          columns.splice(index, 0, column);
        }
      });
    }
    this.props.changeListDataLoading(false);
    const key = this.getKey();
    this.props.case.columns[key] = columns;
    this.props.changeCaseColumns(this.props.case.columns);
  };

  private getKey() {
    const { filterKey, selectedAlarmDomain } = this.props;
    return filterKey ?? selectedAlarmDomain?.dataSource ?? 'default';
  }

  private prepareTransactionFields = async (): Promise<ColumnProps[]> => {
    const { selectedAlarmDomain } = this.props;
    if (selectedAlarmDomain == undefined) {
      return [];
    }
    const transactionQuery = QueryBuilder.select().from(CollectionNames.TRANSACTIONS).where(eq('id', selectedAlarmDomain.dataSource)).build();
    const transaction = await this.repository.find<TransactionJsonModel>(transactionQuery);
    if (transaction == undefined) {
      const allTransactionsQuery = QueryBuilder.select().from(CollectionNames.TRANSACTIONS).build();
      const allTransactions = await this.repository.findMany<TransactionJsonModel>(allTransactionsQuery);
      return [];
    }
    const filteredVariables = transaction.variables.filter((v) => v.name != selectedAlarmDomain.keyField);
    return filteredVariables
      .filter((v) => v.name != selectedAlarmDomain.keyField)
      .map((v) => ({
        field: v.description && v.description.length > 0 ? v.description : v.name,
        sortField: `variables.${v.name}${v.properties.dataType == DataType.STRING ? '.keyword' : ''}`,
        header: v.description && v.description.length > 0 ? v.description : v.name,
        alignHeader: 'left',
        columnKey: `variables.${v.name}`,
        className: `min-w-[300px]`,
        copyable: true,
        filterable: v.properties.dataType != 'Array',
        addFilter:
          v.properties.dataType == DataType.STRUCTURE
            ? undefined
            : (record: TransactionData) => {
                const value = record.variables?.[v.name];
                const field = v.properties.dataType == DataType.STRING ? `variables.${v.name}.keyword` : `variables.${v.name}`;
                this.addFilter(field, value, v.description && v.description.length > 0 ? v.description : v.name, v.properties.dataType);
              },
        onCopy: (record: TransactionData) => {
          const value = record.variables?.[v.name];
          if (value == undefined) return 'N/A';
          switch (v.properties.dataType) {
            case DataType.STRING:
              return value;
            case DataType.NUMBER:
              return typeof value == 'number' ? ValueUtil.formatNumber(value) : value;
            case DataType.DATE:
              return DateFormatUtil.formatForTable(value, (v.properties as DateVariableProperties).format);
            case DataType.BOOLEAN:
              return value ? 'true' : 'false';
            case DataType.OBJECT:
            case DataType.STRUCTURE:
            case DataType.ARRAY:
              return JSON.stringify(value);
            default:
              return value;
          }
        },
        body: (record: TransactionData) => {
          return <div data-testid={`${ComponentName.ACH}_variable_${v.name}_${record.id}`}>
            {this.getTransactionFieldBody(record, v)}
            </div>;
        },
      }));
  };

  private getFilter(props?: Props | Readonly<Props>) {
    const { filterKey, page } = props ?? this.props;
    if (!filterKey) return page.filter;
    return page.filters[filterKey] ?? page.filter;
  }

  private addFilter = async (field: string, value: any, label: string, dataType: DataType, categorical: boolean = false) => {
    const { changePageFilter, onChangeFilter } = this.props;
    const filter: { filter: FilterType; items: CustomFilterFields[] } = this.getFilter();
    if (categorical) {
      filter.filter.fields.push({
        field: field,
        label: label,
        enabled: true,
        search: {
          type: 'CATEGORICAL',
          value: {
            values: [value],
          } as CustomFilterCategorical,
        },
      });
    } else {
      switch (dataType) {
        case DataType.STRING:
        case DataType.NUMBER:
          filter.filter.fields.push({
            field: field,
            label: label,
            enabled: true,
            search: {
              type: 'LITERAL',
              value: {
                properties: {
                  dataType: dataType,
                },
                operator: 'eq',
                value: value,
              } as CustomFilterLiteralSearch,
            },
          });
          break;
        case DataType.DATE:
          filter.filter.fields.push({
            field: field,
            label: label,
            enabled: true,
            search: {
              type: 'DATE',
              value: {
                startDate: {
                  label: DateFormatUtil.formatEpochForDisplay(value),
                  value: value,
                  type: 'Absolute',
                },
                endDate: {
                  label: DateFormatUtil.formatEpochForDisplay(value),
                  value: value,
                  type: 'Absolute',
                },
              } as CustomFilterDateSearch,
            },
          });
          break;
        case DataType.BOOLEAN:
          await this.addFilter(field, value, label, dataType, true);
          break;
        default:
          return;
      }
    }
    changePageFilter(filter);
    onChangeFilter(this.parseFilter());
  };

  private parseFilter = () => {
    const filter = this.getFilter().filter;
    return FilterUtil.parse(filter);
  };

  private getTransactionFieldBody = (record: TransactionData, variable: TransactionVariableJsonModel): any => {
    if (record.variables == undefined) return;
    const value = record.variables[variable.name];
    if (value == undefined) return 'N/A';
    switch (variable.properties.dataType) {
      case DataType.STRING:
        if (value.length == 0) return 'N/A';
        return <CustomTableContentWrapper text={value} clipSize={30} />;
      case DataType.NUMBER: {
        if (typeof value == 'number') return ValueUtil.formatNumber(value);
        if (typeof value == 'string') {
          try {
            const parsed = Number(value);
            if (isNaN(parsed)) {
              return;
            }
            return ValueUtil.formatNumber(parsed);
          } catch (e) {
            return value;
          }
        }
        break;
      }
      case DataType.DATE:
        return (
          <CustomTableContentWrapper
            text={DateFormatUtil.formatForTable(value, (variable.properties as DateVariableProperties).format)}
            tooltipText={DateFormatUtil.formatForTooltip(value, (variable.properties as DateVariableProperties).format)}
            clipSize={50}
          />
        );
      case DataType.BOOLEAN:
        return value || value == 'true' ? 'true' : 'false';
      case DataType.OBJECT:
      case DataType.STRUCTURE:
      case DataType.ARRAY:
        return (
          <a
            className={'text-[#458EF7] text-xs 2xl:text-md'}
            onClick={() => this.setState({ structureVisible: true, structureData: this.getStructureData(value) })}
          >
            Items
          </a>
        );
      default:
        return value;
    }
  };

  private structureModalClose = () => {
    const { structureVisible } = this.state;
    this.setState({ structureVisible: !structureVisible });
  };

  private getStructureData = (data: any): TreeNode[] => {
    let result: TreeNode[] = [];
    for (const key in data) {
      result = result.concat(this.convertItem(data[key], key));
    }
    return result;
  };

  private convertItem(item: any, key: any): TreeNode[] {
    let newItem: TreeNode = {
      key: generateUUID(),
      label: key,
      children: [],
    };
    if (Array.isArray(item)) {
      item.forEach((subItem, index) => {
        const subKey = `${index}`;
        newItem.children = newItem?.children?.concat(this.convertItem(subItem, subKey));
      });
    } else if (typeof item === 'object' && item !== null) {
      for (const subKey in item) {
        newItem.children = newItem?.children?.concat(this.convertItem(item[subKey], subKey));
      }
    } else {
      newItem.label = `${key}: ${typeof item === 'number' ? ValueUtil.formatNumber(item) : item}`;
    }
    return [newItem];
  }

  private getScoreItem = (score: number) => {
    if (score == 0) {
      return 'bg-[#DBF8E5] text-[#3F9E2C]';
    } else if (score > 0 && score < 100) {
      return 'bg-[#FCF1BB] text-[#C57500]';
    } else if (score >= 100) {
      return 'bg-[#FFF1F3] text-[#D2332F]';
    }
  };

  private getStatusItem = (status: TransactionReason | TransactionResultReason) => {
    switch (status) {
      case TransactionReason.FRAUD:
      case TransactionReason.IN_COMPLIANT:
      case TransactionResultReason.DECLINED:
        return 'bg-[#FBE5E4] text-[#C34135]';
      case TransactionReason.NOT_FRAUD:
      case TransactionReason.COMPLIANT:
      case TransactionResultReason.APPROVED:
        return 'bg-[#E8FBF1] text-[#027A48]';
      case TransactionReason.IN_REVIEW:
        return 'bg-[#DFEAFD] text-[#175CD3]';
      case TransactionReason.WAITING_FOR_REVIEW:
        return 'bg-[#F6F6F9] text-[#4F4F4F]';
      case TransactionResultReason.ESCALATED:
        return 'bg-[#FFEEDD] text-[#FF7020]';
      case TransactionReason.ON_HOLD:
        return 'bg-[#FFB55D] text-white';
    }
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    const { onPageChange } = this.props;
    this.setState({ currentPage: event.page, rows: event.rows });
    onPageChange(event.page, event.rows);
  };

  private getStatusText(status: TransactionReason | TransactionResultReason | undefined) {
    if (status == undefined) return 'Unknown';
    switch (status) {
      case TransactionResultReason.DECLINED:
        return 'Declined';
      case TransactionResultReason.APPROVED:
        return 'Approved';
      case TransactionResultReason.ESCALATED:
        return 'Escalated';
      case TransactionReason.IN_REVIEW:
        return 'In Review';
      case TransactionReason.FRAUD:
        return 'Marked as Fraud';
      case TransactionReason.IN_COMPLIANT:
        return 'Marked as Incompliant';
      case TransactionReason.NOT_FRAUD:
        return 'Marked as not Fraud';
      case TransactionReason.COMPLIANT:
        return 'Marked as Compliant';
      case TransactionReason.WAITING_FOR_REVIEW:
        return 'Waiting for Review';
      case TransactionReason.ON_HOLD:
        return 'On Hold';
      default:
        return status;
    }
  }

  private onRowClassName = (record: TransactionData) => {
    const { selectedTransactionId } = this.props;
    const isSelectedId = selectedTransactionId != undefined && selectedTransactionId == record.id;
    const hasError = record.result.failures.length > 0;
    if (isSelectedId) {
      return '!bg-[#F5F5F5] 2xl:!h-[52px] 2xl:!max-h-[52px] !h-[30px] !max-h-[48px] ';
    }
    return `2xl:!h-[52px] 2xl:!max-h-[52px] !h-[30px] !max-h-[48px]  ${hasError ? '!bg-[#FFF7F7]' : 'bg-white'}`;
  };

  private onSelectionChange = (e: any) => {
    dispatch(setSelectedItems(e.value));
  };

  private showFailures = (failures: any[]) => {
    this.setState({ transactionFailures: failures, transactionFailureVisible: true });
  };

  private closeFailures = () => {
    this.setState({ transactionFailures: [], transactionFailureVisible: false });
  };

  private showResult = (result: TransactionResult) => {
    this.setState({ transactionResult: result, transactionResultVisible: true });
  };

  private closeResult = () => {
    this.setState({ transactionResult: undefined, transactionResultVisible: false });
  };

  private onColReorder = (e: DataTableColReorderParams) => {
    const { systemAttributes, selectedAlarmDomain, setAttribute } = this.props;
    if (!Array.isArray(e.columns)) return;
    const columns: ColumnProps[] = (e.columns as any).map((c: any) => c.props);
    const order = columns
      .filter((c) => c.field != undefined)
      .map((c) => c.field)
      .filter((c) => c != undefined) as string[];
    const table = systemAttributes.table.find((t) => t.component == ComponentName.ACH && t.id == selectedAlarmDomain?.dataSource);
    if (table) {
      table.columnOrder = order;
    } else {
      systemAttributes.table.push({
        component: ComponentName.ACH,
        id: selectedAlarmDomain?.dataSource,
        columnOrder: order,
        hiddenColumns: [],
        pageSize: 10,
      });
    }
    setAttribute(systemAttributes);
  };

  private getOrder = (): DataTableSortMeta[] => {
    const { sort } = this.props;
    return sort.map((s) => {
      return {
        field: s.field,
        order: s.operator == 'ASC' ? 1 : -1,
      } as DataTableSortMeta;
    });
  };
}

interface Props extends FormicaProps, ReduxProps {
  transactions: TransactionData[];
  selectedAlarmDomain: CaseSettings | undefined;
  paginationFixed: boolean;
  onPageChange: (page: number, rows: number) => void;
  onSortChange?: (sort: Order[]) => void;
  total: number;
  rows: number;
  currentPage: number;
  openInNewPage?: boolean;
  selectedTransactionId?: string;
  loading?: boolean;
  update?: number;
  multiple?: boolean;
  sort: Order[];
  onChangeFilter: (filter: Filter) => void;
  filterKey?: string;
  fileName?: string;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user as User,
  systemAttributes: state.auth.attributes as UserSystemAttributes,
  component: state.component as ComponentState,
  case: state.case as CaseState,
  page: state.page as PageState,
});

const connector = connect(mapStateToProps, { changeCaseColumns, setAttribute, changeListDataLoading, changePageFilter });
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  rows = 10;
  currentPage = 1;
  transactionFailures: any[] = [];
  transactionFailureVisible: boolean = false;
  transactionResult: TransactionResult | undefined;
  transactionResultVisible: boolean = false;
  structureVisible: boolean = false;
  structureData: TreeNode[] = [];
}

export default withFormica(connector(AchTransactionsActivityComponent));
